module.exports = __webpack_public_path__ + "static/media/argument3_pic1.46d3eac3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/argument3_pic1.jpg
 ** module id = 432
 ** module chunks = 0
 **/